export type PlaceCategory = 'municipal' | 'sport' | 'culture' | 'parc' | 'ecocentre'

export interface Place {
  id: string
  name: string
  category: PlaceCategory
  address: string
  note: string
  open: boolean
  lat: number
  lng: number
}

export const placeCategories: Record<PlaceCategory, { label: string; color: string }> = {
  municipal: { label: 'Services municipaux', color: '#0d4f46' },
  sport: { label: 'Sports et loisirs', color: '#e9554a' },
  culture: { label: 'Culture', color: '#b5342a' },
  parc: { label: 'Parcs et sentiers', color: '#3f6212' },
  ecocentre: { label: 'Écocentres et dépôts', color: '#0f766e' },
}

export const cityCenter: [number, number] = [45.5672, -71.9553]

/**
 * Les lieux sont ceux de la Ville ; les coordonnées sont approximatives et
 * placées à la main — à recaler sur le cadastre avant une présentation.
 */
export const places: Place[] = [
  {
    id: 'hotel-de-ville',
    name: 'Hôtel de ville de Windsor',
    category: 'municipal',
    address: '11, rue Saint-Georges, local 230',
    note: 'Ouvre demain 8 h',
    open: false,
    lat: 45.5686,
    lng: -71.952,
  },
  {
    id: 'bibliotheque',
    name: 'Bibliothèque Patrick-Dignan',
    category: 'culture',
    address: 'Rue Saint-Georges',
    note: 'Ferme à 20 h',
    open: true,
    lat: 45.5679,
    lng: -71.9534,
  },
  {
    id: 'piscine',
    name: 'Piscine municipale et jeux d’eau',
    category: 'sport',
    address: 'Rue Principale',
    note: 'Saison estivale terminée',
    open: false,
    lat: 45.5652,
    lng: -71.9561,
  },
  {
    id: 'centre-sportif',
    name: 'Centre sportif J.A. Lemay',
    category: 'sport',
    address: 'Rue Saint-Georges',
    note: 'Ferme à 22 h',
    open: true,
    lat: 45.5701,
    lng: -71.9498,
  },
  {
    id: 'centre-communautaire',
    name: 'Centre communautaire',
    category: 'culture',
    address: 'Rue Saint-Georges',
    note: 'Ferme à 21 h 30',
    open: true,
    lat: 45.5668,
    lng: -71.9548,
  },
  {
    id: 'parc-poudriere',
    name: 'Parc historique de la Poudrière',
    category: 'parc',
    address: 'Rue du Moulin',
    note: 'Journées de la culture le 26 septembre',
    open: true,
    lat: 45.5745,
    lng: -71.9612,
  },
  {
    id: 'sentiers-poudriere',
    name: 'Sentiers de la Poudrière',
    category: 'parc',
    address: 'Accès par le parc historique',
    note: 'Tarification 2026 en vigueur',
    open: true,
    lat: 45.5762,
    lng: -71.9648,
  },
  {
    id: 'regie-incendie',
    name: 'Régie intermunicipale d’incendie',
    category: 'municipal',
    address: 'Rue Saint-Georges',
    note: 'Urgences : 911',
    open: true,
    lat: 45.5663,
    lng: -71.9502,
  },
  {
    id: 'consignaction',
    name: 'Lieu de retour Consignaction',
    category: 'ecocentre',
    address: 'Windsor',
    note: 'Retour des contenants consignés',
    open: true,
    lat: 45.569,
    lng: -71.947,
  },
  {
    id: 'parc-industriel',
    name: 'Parc industriel de la 55',
    category: 'municipal',
    address: 'Accompagnement par le CDÉW',
    note: 'Développement économique',
    open: true,
    lat: 45.5601,
    lng: -71.942,
  },
  {
    id: 'ecocentre-melbourne',
    name: 'Écocentre de Melbourne',
    category: 'ecocentre',
    address: 'MRC du Val-Saint-François',
    note: 'Hors Windsor · vérifier les heures à la MRC',
    open: false,
    lat: 45.569,
    lng: -72.134,
  },
]
